( function( $ ) {

	window.mxwes_ac_contrast_toggle = function mxwes_ac_contrast_toggle(event){
		
		var contrastToggleTarget = document.querySelector('#contrast-toggle');
		
		if(event.target == contrastToggleTarget){
			event.preventDefault();
			$('html').toggleClass('high-contrast-mode');
			if( $('html').hasClass('high-contrast-mode') ){
				localStorage.setItem('mxwes_high_contrast_mode', 'on');
				
				//Cookies.set('mxwes_high_contrast_mode', 'on', { expires: 365 });
			}else{
				localStorage.setItem('mxwes_high_contrast_mode', 'off');
				
				//Cookies.set('mxwes_high_contrast_mode', 'off', { expires: 365 });
			}
		}
	}
	
	document.addEventListener('click', window.mxwes_ac_contrast_toggle);
	
	window.mxwes_ac_contrast_controls = function mxwes_ac_contrast_controls(event){
		
		var parentID = event.detail.currentItem.parentElement.id;
		var dataValue = event.detail.currentItem.getAttribute('data-value');
		
		
		
		if( (parentID && dataValue) && (parentID == 'high-contrast-controls') ){
			
			localStorage.setItem('mxwes_high_contrast_mode', dataValue);
			
			//Cookies.set('mxwes_high_contrast_mode', dataValue, { expires: 365 });
			
			switch(dataValue){
			
				case 'on':
					$('html').addClass('high-contrast-mode');
					break;
					
				case 'off':
					$('html').removeClass('high-contrast-mode');
					break;	
					
			}	
		}
		
	}
	
	document.addEventListener('radiosSetChecked', window.mxwes_ac_contrast_controls);
	
	
	window.mxwes_ac_color_mode_controls = function mxwes_ac_color_mode_controls(event){
		
		var parentID = event.detail.currentItem.parentElement.id;
		var dataValue = event.detail.currentItem.getAttribute('data-value');
		
		if( (parentID && dataValue) && (parentID == 'color-mode-controls') ){
			
			
			switch(dataValue){
				
				case 'light':
					$('html').removeClass('color-mode--dark').addClass('color-mode--light');
					//localStorage.setItem('mxwes_color_mode', 'light');
					
					//Cookies.set('mxwes_color_mode', 'light', { expires: 365 });
					break;
					
				case 'dark':
					$('html').removeClass('color-mode--light').addClass('color-mode--dark');
					//localStorage.setItem('mxwes_color_mode', 'dark');
					
					//Cookies.set('mxwes_color_mode', 'dark', { expires: 365 });
					break;
					
				case 'auto':
					var colorModeSystemPreference = matchMedia('(prefers-color-scheme: dark)').matches;
					if(colorModeSystemPreference){
						$('html').removeClass('color-mode--light').addClass('color-mode--dark');
					}else{
						$('html').removeClass('color-mode--dark').addClass('color-mode--light');
					}
					
					break;		
				
			}
			
			
			if(dataValue == 'auto'){
				localStorage.removeItem('mxwes_color_mode');
			}else{
				localStorage.setItem('mxwes_color_mode', dataValue);
				
				//Cookies.set('mxwes_color_mode', dataValue, { expires: 365 });
			}
			
			
			
		}
		
	}
	
	document.addEventListener('radiosSetChecked', window.mxwes_ac_color_mode_controls);
	
	
	
	window.mxwes_ac_dyslexic_controls = function mxwes_ac_dyslexic_controls(event){
		
		var parentID = event.detail.currentItem.parentElement.id;
		var dataValue = event.detail.currentItem.getAttribute('data-value');
		
		
		
		if( (parentID && dataValue) && (parentID == 'dyslexic-controls') ){
			
			localStorage.setItem('mxwes_dyslexic_mode', dataValue);
			
			/*
			Cookies.set('mxwes_dyslexic_mode', dataValue, { 
				expires: 1,
				path: '/',
				domain: 'lndo.site',
				secure: true
			});
			*/
			
			switch(dataValue){
			
				case 'off':
					$('html').removeClass('dyslexic-mode');
					break;
					
				case 'on':
					$('html').addClass('dyslexic-mode');
					break;
					
			}	
		}
		
	}
	
	document.addEventListener('radiosSetChecked', window.mxwes_ac_dyslexic_controls);



// Set Active States for Controls (has to load after button group initialization)...css classes set in document ready to reduce flash time
window.addEventListener('load', function () {
	
	var highContrastMode = localStorage.getItem('mxwes_high_contrast_mode');
	//var highContrastMode = Cookies.get('mxwes_high_contrast_mode');
	
	var colorMode = localStorage.getItem('mxwes_color_mode');
	//var colorMode = Cookies.get('mxwes_color_mode');
	
	var colorModeSystemPreference = matchMedia('(prefers-color-scheme: dark)').matches;
	
	var dyslexicMode = localStorage.getItem('mxwes_dyslexic_mode');
	//var dyslexicMode = Cookies.get('mxwes_dyslexic_mode');
	
	if(highContrastMode == 'on'){
		$('#high-contrast-controls').find('[data-value="on"]').click();
	}else{
		$('#high-contrast-controls').find('[data-value="off"]').click();
	}
	
	if(!colorMode || colorMode == 'auto'){
		$('#color-mode-controls').find('[data-value="auto"]').click();
		if(colorModeSystemPreference){
			document.documentElement.classList.remove('color-mode--light');
			document.documentElement.classList.add('color-mode--dark');
		}else{
			document.documentElement.classList.remove('color-mode--dark');
			document.documentElement.classList.add('color-mode--light');
		}
		
	}else if(colorMode == 'dark'){
		$('#color-mode-controls').find('[data-value="dark"]').click();
	}else if(colorMode == 'light'){
		$('#color-mode-controls').find('[data-value="light"]').click();
	}
	
	/*
	if( (colorMode == 'dark') || (!colorMode && colorModeSystemPreference) ){
		$('#color-mode-controls').find('[data-value="dark"]').click();
	}else{
		$('#color-mode-controls').find('[data-value="light"]').click();
	}
	*/
	
	if(dyslexicMode == 'on'){
		$('#dyslexic-controls').find('[data-value="on"]').click();
	}else{
		$('#dyslexic-controls').find('[data-value="off"]').click();
	}
	
});

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change',({ matches }) => {
	
	var colorMode = localStorage.getItem('mxwes_color_mode');
  if (!colorMode && matches) {
	document.documentElement.classList.remove('color-mode--light');
	document.documentElement.classList.add('color-mode--dark');
  } else {
	document.documentElement.classList.remove('color-mode--dark');
	document.documentElement.classList.add('color-mode--light');
  }
  
});


} )( jQuery );

